/// <reference path="typings.d.ts" />

import * as angular from 'angular';

import 'angular-sanitize';
import 'angular-material';
import 'angular-messages';
import 'angular-ui-router';
import 'ng-fab-form/dist/ng-fab-form';
import 'ng-mask-npm';
import 'angular-i18n/angular-locale_pt-br';
import 'ng-infinite-scroll/build/ng-infinite-scroll';
import 'ngstorage/ngStorage';

import './app.scss';

const ngModule = angular
  .module('app', [
    'ngSanitize',
    'ngFabForm',
    'ngMask',
    'ngMaterial',
    'ngMessages',
    'ui.router',
    'infinite-scroll',
    'ngStorage'
  ])
  //.value('API_URL', 'http://localhost/maisfrete/web/api.php');
  .value('API_URL', 'https://m.atua.com.br/web/api.php');

import app from './app.config';
import common from './common/common.config';
import pages from './pages/pages.config';

app(ngModule);
common(ngModule);
pages(ngModule);



/** WEBPACK FOOTER **
 ** ../~/tslint-loader!./index.ts
 **/